import { useQueries } from '@tanstack/react-query'
import { TaskApplication } from '../../../pages/superuser/types'
import { getSourceMapSuggestions } from '../service/sourceMapService'
import sourceMapQueryKeys from './sourceMapQueryKeys'

const SOURCE_ENTITIES = ['Customer', 'Supplier'] as const

export const useSourceMapSuggestions = (companyIds: string[]) =>
  useQueries({
    queries: companyIds.flatMap(companyId =>
      SOURCE_ENTITIES.map(sourceEntity => ({
        queryKey: sourceMapQueryKeys.suggestions({
          companyId,
          source: TaskApplication.FINADECK,
          localEntity: 'Company',
          sourceEntity
        }),
        queryFn: getSourceMapSuggestions,
        enabled: !!companyId,
        gcTime: 15 * 60 * 1000
      }))
    ),
    combine: results => ({
      data: results.flatMap(result => result.data ?? []),
      isLoading: results.some(result => result.isLoading),
      isError: results.some(result => result.isError)
    })
  })
